export const WORKSPACE_VIEWS = [
  'today',
  'tasks',
  'clients',
  'projects',
  'invoices',
  'summary',
] as const

export type WorkspaceView = (typeof WORKSPACE_VIEWS)[number]

export function isWorkspaceView(value: string | null): value is WorkspaceView {
  return WORKSPACE_VIEWS.includes(value as WorkspaceView)
}

export function workspaceViewFromSearch(search: string): WorkspaceView {
  const value = new URLSearchParams(search).get('view')
  return isWorkspaceView(value) ? value : 'today'
}

export function workspaceSearchForView(search: string, view: WorkspaceView): string {
  const params = new URLSearchParams(search)
  if (view === 'today') params.delete('view')
  else params.set('view', view)
  const value = params.toString()
  return value ? `?${value}` : ''
}
